import React from 'react';
import { useIntl } from 'umi';
import { Bubble, Button } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import Image from '@/pages/home/components/GameImage';
import { getEntityImageSizeInfo } from '@/pages/intelligence/utils/topchartsUtils';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';

import type { IBaseProps, IGameType } from '@/pages/intelligence/types/common';

interface IGameListProps extends IBaseProps {
  entityType: IGameType;
  showAddGame: boolean;
  list: any[];
  handleAdd?: () => void;
  handleDel?: (gameId: string, delId: string) => Promise<void>;
  handleGoDetail?: (gameId: string) => void;
  getDetailPath?: (gameId: string) => string;
}

const GameHeader: React.FC<IGameListProps> = (props) => {
  const {
    entityType,
    list,
    showAddGame,
    handleAdd,
    handleDel,
    handleGoDetail,
    getDetailPath,
  } = props;

  const { formatMessage } = useIntl();

  const imageSizeInfo = getEntityImageSizeInfo(entityType);

  const handleClickAdd = () => {
    handleAdd?.();
  };

  const handleClickDel = (gameId: string, delId: string) => {
    handleDel?.(gameId, delId);
  };

  const gotoGameDetail = (gameid: string) => {
    handleGoDetail?.(gameid);
  };

  if (!Array.isArray(list)) {
    return null;
  }

  return (
    <div className="dbi-flex-table dbi-compare-gamelist">
      <div className=" dbi-table-first-colums dbi-table-first-columns">
        <Bubble
          dark
          placement="top-start"
          style={{ maxWidth: 400 }}
          content={
            !showAddGame
              ? formatMessage({ id: 'dbi_compare_select_games_limit_tips' }, { max: 6 })
              : ''
          }
        >
          <div
            className={` dbi-table-first-add ${showAddGame ? '' : 'disable'}`}
            onClick={() => {
              showAddGame ? handleClickAdd() : null;
            }}
          >
            <SvgIcon className="dbi-table-first-icon" type="add-border" />
            <span className="dbi-table-first-text">
              {formatMessage({ id: 'dbi_compare_add_games' })}
            </span>
          </div>
        </Bubble>
      </div>
      {list?.map((item) => (
        <div
          className="dbi-flex-table__table-content"
          key={item?.id}
        >
          <div className="dbi-game-content">
            <SvgIcon
              className="dbi-common-delete-icon dbi-delete-icon"
              type="delete-bg-icon"
              onClick={(e) => {
                e?.stopPropagation();
                e?.preventDefault();
                handleClickDel(item?.game_id, item?.id);
              }}
            />

            <ARightClickToJump
              href={getDetailPath?.(item?.game_id)}
              style={{ display: 'inline' }}
            >
            <div
              className="dbi-game-content__game-item"
              onClick={() => gotoGameDetail(item?.game_id)}
            >
              <div>
                <Image
                  src={item?.cover}
                  imageType={entityType}
                  style={{
                    borderRadius: 4,
                    width: imageSizeInfo?.width || 'auto',
                    height: imageSizeInfo?.height || 'auto',
                  }}
                />
              </div>
              <div className="dbi-compare-mobile-header-flex">
                <span className="dbi-game-name">
                  {item?.name}
                </span>
                <SvgIcon
                  type="other-icon"
                  className="dbi-compare-mobile-header-icon"
                />
              </div>
            </div>
            
          </ARightClickToJump>
          </div>
        </div>
      ))}
      {/* {showAddGame && (
        <div className="dbi-flex-table__table-content dbi-btn-addgame">
          <Button onClick={handleClickAdd}>{formatMessage({ id: 'dbi_compare_add_games' })}</Button>
        </div>
      )} */}
    </div>
  );
};

export default GameHeader;
